import { TSection } from "@data-types/offer/live/Section";
import { PeriodConverter } from "@state";
import { getCurrentCulture } from "@utils/common/culture";
import { slugify } from "@utils/common/slugify";

export const buildRoute = {
	live: (routeElements?: { culture: string; section: string }) => {
		const { culture = getCurrentCulture(), section = TSection.Matches } =
			routeElements || {};

		return `/${culture}/live/${section}`;
	},
	/**
	 * Menu landing
	 * Reset period on menu
	 * */
	prematchLand: (routeElements: { culture: string; period: string }) => {
		const {
			culture = getCurrentCulture(),
			period = PeriodConverter.GetDefaultPeriod(),
		} = routeElements;

		return `/${culture}/sports/${period}/land`;
	},
	/**
	 * Prematch menu  without reset od period
	 * */
	prematch: (routeElements: { culture: string; period: string }) => {
		const {
			culture = getCurrentCulture(),
			period = PeriodConverter.GetDefaultPeriod(),
		} = routeElements;

		return `/${culture}/sports/${period}`;
	},
	tournamentCanonical: (routeElements: {
		culture?: string;
		period?: string;
		sportAbrv: string;
		tournamentAbrv: string;
		tournamentId: string;
	}) => {
		const {
			culture = getCurrentCulture(),
			period = PeriodConverter.GetDefaultPeriod(),
			sportAbrv,
			tournamentAbrv,
			tournamentId,
		} = routeElements;
		const sportSlug = slugify(sportAbrv);
		const tournamentSlug = slugify(tournamentAbrv);
		return `/${culture}/sports/${period}/tournament/${sportSlug}/${tournamentSlug}/${tournamentId}`;
	},
	eventCanonical: (routeElements: {
		culture?: string;
		period?: string;
		eventIds: string;
		teamOneAbrv?: string | null;
		teamTwoAbrv?: string | null;
	}) => {
		const {
			culture = getCurrentCulture(),
			period = PeriodConverter.GetDefaultPeriod(),
			eventIds,
			teamOneAbrv,
			teamTwoAbrv,
		} = routeElements;
		const base = `/${culture}/sports/${period}/event/${eventIds}`;
		const teamOneSlug = slugify(teamOneAbrv);
		const teamTwoSlug = slugify(teamTwoAbrv);
		if (teamOneSlug && teamTwoSlug) {
			return `${base}/${teamOneSlug}-vs-${teamTwoSlug}`;
		}
		return base;
	},
};
